<template>
  <div>
    <div class="main">
      <!-- Right -->
      <div class="main_r">
        <!-- search -->
       <div class="search">
          <div>
            <el-button type="primary" @click="clickBack">返回</el-button>
            <el-button type="primary" @click="clickQuery">刷新</el-button>
          </div>
        </div>
        <!-- search End -->

        <!-- 列表 -->
        <div class="table-section" ref="tableSection">
          <div class="table-container" ref="tableContainer">
        <el-table ref="trainPlanSubTable" row-key="id" :data="dataList" class="mt15 sortable-table" :height="tableHeight" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }">
          <el-table-column label="拖动" width="80">
            <template slot-scope="scope">
              <i class="el-icon-rank drag-handle" title="拖动排序"></i>
            </template>
          </el-table-column>
          <el-table-column prop="weekId" label="第几周第几天" width="160">
            <template slot-scope="props">
              第{{props.row.weekId}}周的第{{props.row.dayId}}天
            </template>
          </el-table-column>
          <el-table-column prop="courseName" label="课程名称"></el-table-column>
          <el-table-column prop="" label="课程列表封面" width="120">
            <template v-slot="scope">
              <img :src="scope.row.courseIcon" min-width="48" height="48" />
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>
          <el-table-column prop="Operation" label="操作" width="280">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="上移" placement="top" :enterable="false">
                <el-link :underline="false" type="primary" icon="el-icon-top" class="mr12" @click="clickMoveUp(scope.$index, scope.row)"></el-link>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="下移" placement="top" :enterable="false">
                <el-link :underline="false" type="primary" icon="el-icon-bottom" class="mr12" @click="clickMoveDown(scope.$index, scope.row)"></el-link>
              </el-tooltip>
              <el-link v-if="scope.row.courseName == ''" :underline="false" type="primary" class="mr12" @click="clickBind(scope.row)">绑定课程</el-link>
              <el-link v-if="scope.row.courseName !== ''" :underline="false" type="danger" class="mr12" @click="clickUnbind(scope.row)">解绑课程</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      </div>
      </div>
      <!-- Right End -->
    </div>

    <!-- 绑定课程 -->
    <el-dialog title="绑定课程" :visible.sync="dialogBind" @open="handleDialogBindOpen" width="90%" class="newAdd" :close-on-click-modal="false">
      <WebTwoTrainPlanDatabaseSubBind ref="SubVuesecond" v-on:triggerFunc="closeDialogBind"></WebTwoTrainPlanDatabaseSubBind>
    </el-dialog>
    <!-- 绑定课程 End -->

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import Sortable from 'sortablejs'
import WebTwoTrainPlanDatabaseSubBind from '@/componentsSubVue/WebTwoTrainPlanDatabaseSubBind.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    WebTwoTrainPlanDatabaseSubBind
  },
  data () {
    return {
      activeName: 'first',
      trainPlanId: '0',
      trainPlanName: '',
      // 列表
      dataList: [],
      tableHeight: 480,
      // 绑定课程
      dialogBind: false,
      dialogBindRow: null,
      sortableInstance: null
    }
  },
  mounted () {
    window.addEventListener('resize', this.onWindowResize)
  },
  beforeDestroy () {
    this.destroySortable()
    window.removeEventListener('resize', this.onWindowResize)
  },
  methods: {
    LoadData (row) {
      this.trainPlanId = row.id
      this.trainPlanName = "【"+row.trainPlanName+"】的每周训练日程"
      this.TrainPlanDatabaseSubList()
    },
    BackToFirst (val) {
      this.dialogBind = false
      this.TrainPlanDatabaseSubList()
    },
    closeDialogBind(){
      this.dialogBind = false
      this.TrainPlanDatabaseSubList()
    },
    clickQuery () {
      this.TrainPlanDatabaseSubList()
    },
    calcTableHeight () {
      var that = this
      this.$nextTick(function () {
        var container = that.$refs.tableContainer
        if (!container) return
        var height = container.clientHeight
        if (height > 0) {
          that.tableHeight = Math.max(240, Math.floor(height))
        }
      })
    },
    onWindowResize () {
      this.calcTableHeight()
    },
    clickBack () {
      this.$emit('triggerFunc', '')
    },
    clickBind(row){
      this.dialogBind = true
      this.dialogBindRow = row
    },
    handleDialogBindOpen(){
      this.$nextTick(() => {
        this.$refs.SubVuesecond.LoadData(this.dialogBindRow);
      });
    },
    clickUnbind(row){
      this.TrainPlanDatabaseSubUpdate(row.id)
    },
    destroySortable () {
      if (this.sortableInstance) {
        this.sortableInstance.destroy()
        this.sortableInstance = null
      }
    },
    initSortable () {
      this.destroySortable()
      var table = this.$refs.trainPlanSubTable
      if (!table) {
        return
      }
      var tbody = table.$el.querySelector('.el-table__body-wrapper tbody')
      if (!tbody) {
        return
      }
      var that = this
      this.sortableInstance = Sortable.create(tbody, {
        handle: '.drag-handle',
        animation: 150,
        onEnd: function (evt) {
          if (evt.oldIndex === evt.newIndex) {
            return
          }
          var moved = that.dataList.splice(evt.oldIndex, 1)[0]
          that.dataList.splice(evt.newIndex, 0, moved)
          that.saveSortOrder()
        }
      })
    },
    saveSortOrder () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.trainPlanId = that.trainPlanId
      that.dataList.forEach(function (row, index) {
        data['orderedIds[' + index + ']'] = row.id
      })
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanDatabaseSubUpdateSort, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            Vue.prototype.$message.success('排序已保存')
            that.TrainPlanDatabaseSubList()
          } else {
            that.TrainPlanDatabaseSubList()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.TrainPlanDatabaseSubList()
        })
    },
    clickMoveUp (index, row) {
      if (index === 0) {
        Vue.prototype.FunRemindAllways('已经是第一条了')
        return
      }
      var list = this.dataList.slice()
      var temp = list[index - 1]
      list[index - 1] = list[index]
      list[index] = temp
      this.saveSortOrderWithList(list)
    },
    clickMoveDown (index, row) {
      if (index === this.dataList.length - 1) {
        Vue.prototype.FunRemindAllways('已经是最后一条了')
        return
      }
      var list = this.dataList.slice()
      var temp = list[index + 1]
      list[index + 1] = list[index]
      list[index] = temp
      this.saveSortOrderWithList(list)
    },
    saveSortOrderWithList (list) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.trainPlanId = that.trainPlanId
      list.forEach(function (row, index) {
        data['orderedIds[' + index + ']'] = row.id
      })
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanDatabaseSubUpdateSort, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success('操作成功')
            that.TrainPlanDatabaseSubList()
          } else {
            Vue.prototype.FunRemindAllways(response.data.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    TrainPlanDatabaseSubList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.trainPlanId = that.trainPlanId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanDatabaseSubList, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataList = response.data.data
            that.$nextTick(function () {
              that.calcTableHeight()
              that.initSortable()
            })
          }
          console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    TrainPlanDatabaseSubUpdate: function (id) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = id
      data.courseId = '0'
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanDatabaseSubUpdate, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.TrainPlanDatabaseSubList()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.table-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 12px;
}

.table-container {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  overflow: hidden;
}

.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 300px;
    margin-right: 15px;
  }

  .el-select{
    margin-right: 15px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}
.newAdd /deep/ .el-dialog__body {
  padding: 1px 20px 15px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}

.drag-handle {
  cursor: move;
  color: #909399;
  font-size: 18px;
}

.drag-handle:hover {
  color: #4976ff;
}
</style>
